/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'
import { get } from 'lodash'

/**
 * Import
 * - Store
 */
import { RootState } from '../../../../store'

/**
 * Import
 * - Actions
 */
import { getFullQuoteRenewal, getFullQuote } from '../../../../actions'

/**
 * Import
 * - Page component
 */
import EditRenewals from '../../../../components/pages/Renewals/EditRenewals/EditRenewals'

const mapStateToProps = (state: RootState) => {
    return {
        quote: state.quote,
        renewalsId: get(state, 'quote.fullRenewals.response.renewal.id', false),
        inceptionDate: get(state, 'quote.fullRenewals.response.renewal.inceptionDate', false),
        isCollectors: get(state, 'quote.fullRenewals.response.renewal.isCollectors', false),
        isMuseums: get(state, 'quote.fullRenewals.response.renewal.isMuseums', false),
        isDealersStock: get(state, 'quote.fullRenewals.response.renewal.isDealersStock', false),
        isWineSpirits: get(state, 'quote.fullRenewals.response.renewal.isWineSpirits', false),
        isWineSpiritsSteve: get(state, 'quote.fullRenewals.response.renewal.isWineSpiritsSteve', false),
    }
}

export default connect(
    mapStateToProps,
    {
        getFullQuoteRenewal: getFullQuoteRenewal,
        getFullQuote,
    }
)(EditRenewals)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Renewals/EditRenewals/EditRenewals.tsx